import axios from 'axios';
import CryptoJS from 'crypto-js';

const API_BASE_URL = 'http://118.34.123.87:8765';

export class CCTVRequester {
    constructor() {
        this.client = axios.create({
            baseURL: API_BASE_URL,
            timeout: 10000,
            withCredentials: false,
            headers: {
                'Content-Type': 'application/json',
            },
            validateStatus: function (status) {
                return status >= 200 && status < 300; // 200-299 상태 코드를 성공으로 처리
            }
        });
    }

    computeSignature(method, path, body, password) {
        const url = new URL(path, API_BASE_URL);
        const params = new URLSearchParams(url.search);
        params.sort();
        params.delete('_signature');

        const encodedQuery = Array.from(params.entries())
            .map(([k, v]) => `${k}=${encodeURIComponent(v).replace(/['()*~]/g, encodeURIComponent)}`)
            .join('&');

        const cleanedPath = `${url.pathname}${encodedQuery ? `?${encodedQuery}` : ''}`;
        const bodyStr = body && !body.startsWith('---') ? body.replace(/[^a-zA-Z0-9_-]/g, '-') : '';
        const cleanedPassword = password.replace(/[^a-zA-Z0-9_-]/g, '-');

        const signatureBase = `${method}:${cleanedPath}:${bodyStr}:${cleanedPassword}`;
        return CryptoJS.SHA1(signatureBase).toString(CryptoJS.enc.Hex).toLowerCase();
    }

    async getCameraList(token) {
        try {
            // JWT에서 username 추출
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            const username = decodedToken.userName;

            // signature 생성을 위한 임시 password (원본과 동일하게 'admin' 사용)
            const tempPassword = CryptoJS.SHA1('admin').toString(CryptoJS.enc.Hex);

            const path = `/config/list/?_username=${username}`;
            const signature = this.computeSignature('GET', path, '', tempPassword);

            const response = await this.client.get(`${path}&_signature=${signature}`, {
                withCredentials: false,
                headers: {
                    'Accept': 'application/json',
                }
            });
            return response.data.cameras;
        } catch (error) {
            console.error('Error in getCameraList:', error);
            throw error;
        }
    }

    async getCameraImage(cameraId, token) {
        try {
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            // const username = decodedToken.userName;
            const username = 'admin';
            const tempPassword = CryptoJS.SHA1('admin').toString(CryptoJS.enc.Hex);

            const timestamp = Date.now();
            const path = `/picture/${cameraId}/current/?_=${timestamp}&_username=${username}`;
            const signature = this.computeSignature('GET', path, '', tempPassword);

            const response = await this.client.get(`${path}&_signature=${signature}`, {
                responseType: 'blob',
                withCredentials: false,
                headers: {
                    'Accept': 'image/webp,image/apng,image/*,*/*;q=0.8',
                }
            });
            return response.data;
        } catch (error) {
            console.error(`Error fetching camera ${cameraId} image:`, error);
            throw error;
        }
    }

    async getCameraWithStoreCode(cameraId, token) {
        try {
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            // const username = decodedToken.userName;            
            const username = 'admin';

            const tempPassword = CryptoJS.SHA1('admin').toString(CryptoJS.enc.Hex);

            const path = `/config/${cameraId}/get_with_store_code/?_username=${username}`;
            const signature = this.computeSignature('GET', path, '', tempPassword);

            const response = await this.client.get(`${path}&_signature=${signature}`, {
                withCredentials: false,
                headers: {
                    'Accept': 'application/json',
                }
            });
            return response.data; // { json: {...}, store_code: "..." }
        } catch (error) {
            console.error(`Error fetching camera ${cameraId} with store code:`, error);
            throw error;
        }
    }

    async getCamerasByStoreCodes(storeCodes, token) {
        try {
            const decodedToken = JSON.parse(atob(token.split('.')[1]));
            const username = decodedToken.userName;
            const tempPassword = CryptoJS.SHA1('admin').toString(CryptoJS.enc.Hex);

            // storeCodes는 문자열 배열이라고 가정
            const storeCodesParam = storeCodes.join(',');
            const path = `/config/get_by_store_codes/?store_codes=${storeCodesParam}&_username=${username}`;
            const signature = this.computeSignature('GET', path, '', tempPassword);

            const response = await this.client.get(`${path}&_signature=${signature}`, {
                withCredentials: false,
                headers: {
                    'Accept': 'application/json',
                }
            });
            return response.data.cameras; // [{ id: 1, json: {...}, store_code: "..." }, ...]
        } catch (error) {
            console.error('Error fetching cameras by store codes:', error);
            throw error;
        }
    }
} export default CCTVRequester